import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetAvailableLanguages } from "../../hooks/global/Languages";
import GroupProductsEditForm from "./GroupProductsEditForm";


function GroupProductsListItem({ id, moduleId,  product }) {
    const { t, i18n } = useTranslation();
    const [ isOpen, setIsOpen ] = useState(false);
    const availableLan = useGetAvailableLanguages();

    return (
        <div className="productSingle">
            {(!isOpen) ? (
                <div className={"productSingleInner " + (product.status === "DISABLED" ? "productSingleDisabled" : "")}>
                    <div className="productSingleInnerWrap" onClick={() => setIsOpen(!isOpen) }>

                        {availableLan.map((lng, key) => {
                            return (
                                <div key={lng}>
                                    <p>
                                        <strong>{lng}: </strong>
                                        {product.name[lng]}
                                        {!product.name[lng] && <span className="noTranslation" />}
                                    </p>
                                </div>
                            )
                        })}

                    </div>
                    <button onClick={() => console.log("aloha klik")}
                        className="btn btn-default btn-edit btn-editInput"
                        title={t("admin.group.editE")}>{t("admin.group.editE")}</button>
                </div>
            ) : (<GroupProductsEditForm id={id} moduleId={moduleId} onClose={() => setIsOpen(false)} />)}
        </div>
    );
}

export default GroupProductsListItem;
